<template>
  <md-dialog class="" :md-close-on-esc="false" :md-click-outside-to-close="false" :md-closed="closeDialog"
             :md-opened="openDialog"
             :md-active.sync="options.showClientForm">
    <md-dialog-title class="ml-30 mt-20">
      {{ _currentClient ? 'Mandant bearbeiten' : 'Neuer Mandant' }}
    </md-dialog-title>
    <md-dialog-content class="pb-40">
      <div class="pt-30">
        <form novalidate class="md-layout" @submit.prevent="validate">

          <div class="md-layout md-layout-item md-gutter w-100 md-size-100">
            <div class="md-layout-item">
              <md-field
                  :class="getValidationClass('company')"
                  class="md-focused">
                <label for="company">Firmenname</label>
                <md-input name="company" id="company" placeholder="Firmenname"
                          v-model="form.company"
                          :disabled="sending"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field
                  :class="getValidationClass('int_id')"
                  class="md-focused">
                <label for="int_id">Kundennummer</label>
                <md-input name="int_id" id="int_id" placeholder="Kundennummer"
                          v-model="form.int_id"
                          :disabled="sending"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field
                  :class="getValidationClass('phone')"
                  class="md-focused">
                <label for="phone">Telefonnummer</label>
                <md-input name="phone" id="phone" placeholder="Telefonnummer"
                          v-model="form.phone"
                          :disabled="sending"/>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-layout-item md-gutter w-100 md-size-100 pt-30">
            <div class="md-layout-item">
              <md-field
                  :class="getValidationClass('email')"
                  class="md-focused">
                <label for="email">E-Mail-Adresse</label>
                <md-input name="email" id="email" placeholder="E-Mail-Adresse"
                          v-model="form.email"
                          :disabled="sending"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field
                  :class="getValidationClass('website')"
                  class="md-focused">
                <label for="website">Webseite</label>
                <md-input name="website" id="website" placeholder="Webseite"
                          v-model="form.website"
                          :disabled="sending"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field
                  :class="getValidationClass('placetel_key')"
                  class="md-focused">
                <label for="placetel_key">Telefonnummer</label>
                <md-input name="placetel_key" id="Placetel API Key" placeholder="Placetel API Key"
                          v-model="form.placetel_key"
                          :disabled="sending"/>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter md-layout-item w-100 md-size-100 pt-30">
            <div class="md-layout-item">
              <md-field
                  :class="getValidationClass('pkv_ldap')"
                  class="md-focused">
                <label for="pkv_ldap">PKV Wert in LDAP</label>
                <md-input name="pkv_ldap" id="pkv_ldap" placeholder="PKV Wert in LDAP"
                          v-model="form.pkv_ldap"
                          :disabled="sending"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field
                  :class="getValidationClass('pkv_phone')"
                  class="md-focused">
                <label for="pkv_phone">Telefon PKV Referenz</label>
                <md-input name="pkv_phone" id="pkv_phone" placeholder="Telefon PKV Referenz"
                          v-model="form.pkv_phone"
                          :disabled="sending"/>
              </md-field>
            </div>
            <div class="md-layout-item">
              <div class="md-layout-item ">
                <md-checkbox :disabled="sending" v-model="form.callback_pkv" :value="1"
                             class="md-primary">PKV
                </md-checkbox>
              </div>
              <div class="md-layout-item">
                <md-checkbox :disabled="sending" v-model="form.callback_gkv" :value="1"
                             class="md-primary">GKV
                </md-checkbox>
              </div>
              <div class="md-layout-item">
                <md-checkbox :disabled="sending" v-model="form.crm_tool" :value="1"
                             class="md-primary">CRM-Tool
                </md-checkbox>
              </div>
              <div class="md-layout-item">
                <md-checkbox :disabled="sending" v-model="form.phone_tool" :value="1"
                             class="md-primary">Telefontool
                </md-checkbox>
              </div>
            </div>
          </div>

        </form>
      </div>
    </md-dialog-content>
    <md-dialog-actions class="mt-20">
      <div class="p-30">
        <md-button v-if="options.clientFormEditable" class="md-raised md-primary"
                   @click="save">
          {{ _currentClient ? 'Kunde speichern' : 'Neuen Kunden anlegen' }}
        </md-button>
        <md-button class="md-raised secondary" @click="closeDialog">
          {{ 'Schließen' }}
        </md-button>
      </div>
    </md-dialog-actions>
    <Success :options="options"></Success>
  </md-dialog>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {
  required,
  email,
} from 'vuelidate/lib/validators';
import Success from '../../components/dialogs/Success.vue'


export default {
  name: 'formClient',
  mixins: [validationMixin],
  props: {
    options: {
      type: Object,
      required: true
    },
    currentSupplier: {
      type: Object
    },
  },
  components: {
    Success
  },
  data: () => ({
    hideCols: [],
    form: {
      company: null,
      int_id: null,
      phone: null,
      email: null,
      website: null,
      placetel_key: null,
      pkv_ldap: null,
      pkv_phone: null,
      callback_pkv: 0,
      callback_gkv: 0,
      crm_tool: 0,
      phone_tool: 0,
    },
    clientSaved: false,
    _currentClient: null,
    sending: false,
    isLoaded: false,
  }),
  validations: {
    form: {
      company: {
        required,
      },
      int_id: {
        required,
      },
      phone: {
        required,
      },
      email: {
        required,
        email
      },
      website: {
        required,
      },
      placetel_key: {
        required,
      },
      pkv_ldap:{
        required,
      },
      pkv_phone: {
        required,
      },
      callback_pkv: {
        required,
      },
      callback_gkv: {
        required,
      },
      crm_tool: {
        required,
      },
      phone_tool: {
        required,
      },
    }
  },
  watch: {
    currentClient: {
      handler(newValue) {
        let self = this;
        if (newValue) {
          self._currentClient = newValue ? newValue : null;
          self.form.id = newValue ? newValue.id : 'auto';
          self.form.company = newValue ? newValue.company : null;
          self.form.int_id = newValue ? newValue.int_id : null;
          self.form.email = newValue ? newValue.email : null;
          self.form.phone = newValue ? newValue.phone : null;
          self.form.website = newValue ? newValue.website : null;
          self.form.address = newValue ? newValue.address : null;
          self.form.placetel_key = newValue ? newValue.placetel_key : null;
          self.form.pkv_ldap = newValue ? newValue.pkv_ldap : null;
          self.form.pkv_phone = newValue ? newValue.pkv_phone : null;
          self.form.callback_pkv = newValue ? newValue.callback_pkv : 0;
          self.form.callback_gkv = newValue ? newValue.callback_gkv : 0;
          self.form.crm_tool = newValue ? newValue.crm_tool : 0;
          self.form.phone_tool = newValue ? newValue.phone_tool : 0;
        }
      },
      deep: true,
      immediate: true,
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm() {
      let self = this;
      this.$v.$reset()
      this.form.company = null
      this.form.int_id = null
      this.form.email = null
      this.form.phone = null
      this.form.website = null
      this.form.placetel_key = null
      this.form.pkv_ldap = null
      this.form.pkv_phone = null
      this.form.callback_pkv = 0
      this.form.callback_gkvl = 0
      this.form.crm_tool = 0
      this.form.phone_tool = 0
    },
    openDialog() {

    },
    closeDialog() {
      this.clearForm();
      this.options._currentClient = null;
      this.options.clientFormEditable = true;
      this.options.showClientForm = this.options.showClientDetails = false;
    },
    save() {
      let self = this;
      self.$v.$touch()
      if (self.$v.$invalid) {
        return false;
      }
      this.sending = true;
      this.doPost({
        userdata: self.options.user,
        data: self.form
      }, this._currentClient ? 'updateClient' : 'createClient', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.newClientCreated++;
          self.options.showSuccess = true;
          self.$emit('updateData', {});
          self.closeDialog();
        }
      })
    },
    validate() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.save()
      }
    }
  }
}
</script>